'use client';

import * as SeparatorPrimitive from '@radix-ui/react-separator';
import type { ComponentProps } from 'react';
import { cn } from '../../utils';

function Separator({
  className,
  orientation = 'horizontal',
  decorative = true,
  label,
  ...props
}: ComponentProps<typeof SeparatorPrimitive.Root> & {
  label?: string;
}) {
  return (
    <div className={cn('relative w-full', !label && 'contents')}>
      <SeparatorPrimitive.Root
        data-slot="separator"
        decorative={decorative}
        orientation={orientation}
        className={cn(
          'shrink-0 bg-border',
          orientation === 'horizontal' ? 'h-[1px] w-full' : 'h-full w-[1px]',
          className
        )}
        {...props}
      />
      {!!label && (
        <p className="-translate-y-1/2 -translate-x-1/2 absolute top-1/2 left-1/2 bg-white px-2 text-center font-light text-gray-400 text-sm">
          {label}
        </p>
      )}
    </div>
  );
}

export { Separator };
